<template>
	<div class="header-page">
    <div class="header-content" @touchmove.prevent>
        <div class="disflex" style="justify-content: space-between;">
          <a class="back" href="javascript:void(0)" @click="goBack" style="margin-top: 0px;margin-left: 20px;">
            <img width="130" src="../../static/images/back_myid.png" />
          </a>
<!--          <a class="logo" href="/"><img src="static/images/logo2.png" /></a>-->

          <div class="logo-row" @click="goSelectPage">
            <div class="logo-combo" aria-label="app logos">
              <img class="logo-combo-bg"  src="/static/images/select_page/select_logo_bg.png" alt="logo background">
              <div class="logo-combo-icons"><img class="logo-combo-icon" src="/static/images/select_page/select_chineasy_logo.png" alt="Chineasy logo">
                <img class="logo-combo-icon" src="/static/images/select_page/select_japaneasy_logo.png" alt="Japaneasy logo">
              </div>
            </div>
          </div>

          <div class="account ac" @click="getMenu('myAccount')">
            <img class="account-img" :src="avatar" />
          </div>
        </div>
    </div>
	</div>
</template>

<script>
    import Dialog from '../components/dialog'
    export default {
      props: ['message'],
        name: 'app-header',
        components:{
          Dialog
        },
        data () {
            return {
              info:{},
              isShow:false,
              isActive:false,
              isShowMenu:false,
              isLogin:false,
              isEnShow:false,
              lang:'',
              isShowLang:'bur',
              avatar: "",
            }
        },
        created(){
          if(localStorage.getItem('lang')){
            this.isShowLang = localStorage.getItem('lang')
          }

          this.avatar = localStorage.getItem('avatar')?localStorage.getItem('avatar'):"../../static/images/account.png";
        },
		methods: {
      getLan(){
        let that = this
        that.$refs.imgDialog.showMaskFun();
      },
      closeTmgDialog(){
        this.$refs.imgDialog.closeMask();
      },
      goSelectPage(){
        this.$router.push({path:'/select'});
      },
      getLang(type,lang){
        if(type==1){
          localStorage.setItem('lang',this.lang)
          location.reload()
        }else{
          this.isShowLang = lang
          this.lang = lang
        }
      },
      getMenu(url){
          this.isShowMenu = url
          let that = this
          setTimeout(function(){
            that.$router.push({path:url,query:{url:url}});
          },500);
      },
			getAcount(){
				let that =this;
			  this.isActive = true;
        this.getInfo()
			},
      getShowLogin(){
        this.$router.push({path:'/login'})
      },
      unSubscribe(){
      	let that =this;
      	that.$parent.$parent.loadModal(true);
      	that.$api.post('api/user/unsub',null,r =>{
      		that.$parent.$parent.returnCode(r,function(){
      	    that.$parent.$parent.loadModal(false);
            that.$utils.alertText(r.msg,80);
      	    localStorage.removeItem('token')
      	    localStorage.removeItem('mobile')
            // that.$router.push({path:'/login'});
            window.location.href = "https://snapai.asia/"
      	  });
      	})
      },
      getInfo (){
        let that =this;
        that.$parent.$parent.loadModal(true);
        that.$api.post('/api/user/info',null,r =>{
        	that.$parent.$parent.returnCode(r,function(){
            that.info = r.data
            localStorage.setItem('info',r.data.score)
            localStorage.setItem('int_url',r.data.invite_url)
            localStorage.setItem('avatar',r.data.avatar)
            that.$parent.$parent.loadModal(false);
          });
        })
      },
      goBack() {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          window.location.href = "mytel://back";
        }else if (/Android/i.test(navigator.userAgent)) {
          window.location.href = "mytel://back";
        }else{
          window.location.href = "mytel://back";
        }
      }
		}
    }
</script>
<style scoped>

.logo-row {
  display: flex;
  justify-content: center;

}

.logo-combo {
  position: relative;
  width: clamp(150px, 30vw, 260px);
  height: clamp(95px, 16vw, 90px);
}

.logo-combo-bg {
  width: 100%;
  height: 100%;
  display: block;
}

.logo-combo-icons {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(10px, 2.6vw, 14px);
}

.logo-combo-icon {
  width: clamp(90px, 16vw, 92px);
  height: auto;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue